export default {
  setModelsMetaData(state, data) {
    state.modelsMetaData = data
  },
}
